import { useState, useEffect, useRef } from "react";
import type { Orientation } from "@jnctn/types/Orientation";

// Tracks orientation changes
export default function useOrientation() {
  const mediaQueryRef = useRef<MediaQueryList>(
    window.matchMedia("screen and (orientation: landscape)")
  );
  const [orientation, setOrientation] = useState(getOrientation());

  function getOrientation(): Orientation {
    if (mediaQueryRef.current) {
      return mediaQueryRef.current.matches ? "landscape" : "portrait";
    }
    return "portrait";
  }

  useEffect(() => {
    const onScreenOrientationChange = () => {
      setOrientation(getOrientation());
    };

    try {
      const { current } = mediaQueryRef;
      current.addEventListener("change", onScreenOrientationChange);
      return () => {
        current.removeEventListener("change", onScreenOrientationChange);
      };
    } catch (e) {
      // Handle old API
      const { current } = mediaQueryRef;
      (current as any).addListener(onScreenOrientationChange);
      return () => {
        (current as any).removeListener(onScreenOrientationChange);
      };
    }
  }, []);

  return orientation;
}
